import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';

import { PlacementDocumentItem } from '@/api';
import CardGererContrat from '@/components/CardGererContrat/CardGererContrat';
import { ContractDocuments } from '@/components/ContractDocuments/ContractDocuments';
import DemoTag from '@/components/DemoTag/DemoTag';
import { useDemoContext } from '@/hooks/DemoContext';

import styles from './styles.module.css';

interface ContractDocumentsTabProps {
  documents: PlacementDocumentItem[] | null | undefined;
  paymentSlipsSubtitle: string;
  documentsTabTitle: string;
  otherDocumentsTabTitle: string;
  partnerCardDescription: string;
  insuranceLink: string;
  insuranceLogo?: string | null;
  contractName?: string | null;
}

export const ContractDocumentsTab: React.FC<ContractDocumentsTabProps> = ({
  documents,
  paymentSlipsSubtitle,
  documentsTabTitle,
  otherDocumentsTabTitle,
  partnerCardDescription,
  insuranceLink,
  insuranceLogo,
  contractName,
}) => {
  const { isDemo } = useDemoContext();
  return (
    <>
      {documents?.length && (
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionTitle}>
            {paymentSlipsSubtitle}
            {isDemo && <DemoTag />}
          </h2>
          <ContractDocuments documentsInfos={documents} />
        </div>
      )}
      <div className={styles.sectionCard}>
        <h2 className={styles.sectionTitle}>{documents?.length ? otherDocumentsTabTitle : documentsTabTitle}</h2>
        <MtxGrid row>
          <MtxGrid col={4} colXs={12} colSm={6} colMd={6} colLg={4}>
            <CardGererContrat
              insuranceLink={insuranceLink}
              insuranceLogo={insuranceLogo}
              contractName={contractName}
              isLogo={true}
              isAsideInfo={false}
              description={partnerCardDescription}
            />
          </MtxGrid>
        </MtxGrid>
      </div>
    </>
  );
};
